import { SUBMIT_REGISTRATION, UPDATE_REGISTRATION, VALIDATE_SESSIONS } from '@gameday/common/constants/endpoints'

export default {
  validateSessions: VALIDATE_SESSIONS, // 'gamedayapi/forms/sessions',
  submitRegistrations: SUBMIT_REGISTRATION, // 'gamedayapi/registrations',
  updateRegistrations: UPDATE_REGISTRATION, // 'gamedayapi/registrations/orders',
}
